<template>
  <BaseModal>
    <ModalContainer class="confirm-reject-task__container">
      <ModalTitle>
        {{ $t('approvals.REJECT_TASK') }}
      </ModalTitle>
      <ModalBody>
        <ModalParagraph>
          {{ $t('approvals.REJECT_CONFIRM_DESCRIPTION') }}
        </ModalParagraph>
        <ModalParagraph>
          <b> {{ $t('approvals.REJECT_TASK_CONFIRM_TITLE') }} </b>
        </ModalParagraph>
      </ModalBody>
      <DialogModalActions
        :cancel-text="$t('buttons.CANCEL').toString()"
        :cta-button-text="$t('approvals.REJECT_TASK').toString()"
        cta-button-theme="red"
        @onCancel="closeDialog"
        @onConfirm="rejectTask"
      />
    </ModalContainer>
  </BaseModal>
</template>

<script setup lang="ts">
import BaseModal from '@/components/generics/base/BaseModal.vue'
import DialogModalActions from '@/components/generics/modals/DialogModalActions.vue'
import ModalBody from '@/components/generics/modals/ModalBody.vue'
import ModalContainer from '@/components/generics/modals/ModalContainer.vue'
import ModalParagraph from '@/components/generics/modals/ModalParagraph.vue'
import ModalTitle from '@/components/generics/modals/ModalTitle.vue'
import { useI18n } from '@/hooks/useI18N'
import { useToast } from '@/hooks/useToast'
import { useRejectUserActivityTask } from '@/queries/activities/activitiesMutation'

const props = defineProps<{
  productId: string
  activityItemUserId: string
  userId: string
}>()

const { doToast } = useToast()
const emits = defineEmits(['close'])

const closeDialog = () => {
  emits('close')
}

const i18n = useI18n()

const { mutateAsync } = useRejectUserActivityTask()

const rejectTask = async () => {
  await mutateAsync(
    {
      productId: props.productId.toString(),
      userId: props.userId.toString(),
      activityItemUserId: props.activityItemUserId.toString(),
    },
    {
      onSuccess: () => {
        closeDialog()
      },
      onError: () => {
        doToast({
          theme: 'error',
          text: i18n.t('approvals.ERROR_REJECTING_TASK').toString(),
        })
      },
    }
  )
}
</script>

<style scoped lang="scss">
.confirm-reject-task__container {
  max-width: 500px;
}
</style>
